import PropTypes from "prop-types"
import React, { useState } from "react"

import { connect } from "react-redux"

import { Link } from "react-router-dom"
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined"
import { useSelector } from "react-redux"
import "../../newcomponents/index.css"
import VerifiedIcon from "@mui/icons-material/Verified"
// Reactstrap
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

// Import menuDropdown
import LanguageDropdown from "../CommonForBoth/TopbarDropdown/LanguageDropdown"
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ExtrasDropdown from "../CommonForBoth/TopbarDropdown/extras"
import OrganizationDropDown from "../CommonForBoth/TopbarDropdown/OrganizationDropDown"
import Breadcrumbs from "../../newcomponents/breadcrumb"
import UserDropdown from "../../newcomponents/user-dropdown"
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
// import megamenuImg from "../../assets/images/megamenu-img.png"
import logo from "../../assets/images/logo-sm.png"
import logoLightPng from "../../assets/images/logo-light.png"
import logoDark from "../../assets/images/logo-dark.png"

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions"

const Header = props => {
  const { leftSideBarType, changeSidebarType } = props
  const [search, setsearch] = useState(false)
  const [createmenu, setCreateMenu] = useState(false)
  const user = useSelector(state => state.Login.userData)
  const userData = useSelector(state => state.Login.userData)
  const theme = useSelector(state => state.Theme.mode)
  const mode = useSelector(state => state.Layout.layoutMode)
  const buttonSize = 30
  const halfBtn = buttonSize / 2
  // const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT,
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }
  const [isSidebarClosed, setIsSidebarClosed] = useState(true) // start open

  function tToggle() {
    setIsSidebarClosed(prev => {
      const next = !prev
      if (next) {
        document.body.classList.remove("vertical-collpsed")
        document.body.classList.add("sidebar-enable")
      } else {
        document.body.classList.add("vertical-collpsed")
        document.body.classList.remove("sidebar-enable")
      }
      return next
    })
  }

  return (
    <React.Fragment>
      <header
        className={`app-header ${leftSideBarType === "condensed" ? "collapsed" : "expanded"}`}
        style={{
          position: "fixed",
          top: 10,
          left: leftSideBarType === "condensed" ? "90px" : "260px",
          right: "20px",
          // width: auto when left+right are set
          backgroundColor: mode === "dark" ? "#252F40" : "#fff",
          borderRadius: "12px",
          padding: "10px 20px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          transition: "all 0.1s ease",
          zIndex: 1000,
          overflow: "visible",
        }}
      >
        <button
          type="button"
          onClick={() =>
            changeSidebarType(
              leftSideBarType === "condensed" ? "default" : "condensed",
            )
          }
          style={{
            position: "absolute",
            top: "30px",
            left: `-${halfBtn}px`,
            width: `${buttonSize}px`,
            height: `${buttonSize}px`,
            borderRadius: "50%",
            backgroundColor: "#E9EBEF",
            border: "none",
            zIndex: 1100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {leftSideBarType === "default" ? (
            <KeyboardArrowLeftIcon style={{ color: "#050409" }} />
          ) : (
            <KeyboardArrowRightIcon style={{ color: "#050409" }} />
          )}
        </button>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            // marginLeft: "100px",
          }}
          className=""
        >
          <div className="d-flex">
            <div className="d-flex align-items-center">
              <div
                style={{
                  marginBottom: "25px",
                }}
              >
                <Breadcrumbs />
              </div>
              {/* <button
                type="button"
                onClick={() =>
                  changeSidebarType(
                    leftSideBarType === "condensed" ? "default" : "condensed",
                  )
                }
                className="btn btn-sm px-3 font-size-24 header-item waves-effect vertical-menu-btn"
                id="vertical-menu-btn"
              >
                <i className="mdi mdi-menu"></i>
              </button> */}
            </div>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {/* <LanguageDropdown /> */}
            <div className="dropdown d-none d-lg-inline-block"></div>
            <ExtrasDropdown />
            <NotificationDropdown />
            <OrganizationDropDown />
            {/* <ProfileMenu /> */}
            <UserDropdown user={userData} />
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
}

const mapStatetoProps = state => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
    state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
